import React from "react";
import Breadcrumb from "../../../common/Breadcrumb";
import BlogDetailsWrap from "./BlogDetailsWrap";

function BlogDetailsPage() {
  return (
    <>
      <Breadcrumb name="Blog Details" />
      <BlogDetailsWrap />
    </>
  );
}

export default BlogDetailsPage;
